import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Root',
        component: () => import('@/pages/PriceCalculatorPage.vue')
    },
    {
        path: '/pris',
        name: 'Pris',
        component: () => import('@/pages/UserCalculatorPage.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
